

// l&f pdp accordion script
document.querySelectorAll('.accordion-header').forEach(header => {
  header.addEventListener('click', () => {
    const item = header.parentElement;
    const isActive = item.classList.contains('active');

    // Close all items
    document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('active'));

    // Re-open clicked if not already open
    if (!isActive) {
      item.classList.add('active');
    }
  });
});

//Custom code for popup Event 4-8-2025
// Add to Cart DataLayer Push
const addToCartButtons = document.querySelectorAll('[data-js-product-add-to-cart]');

addToCartButtons.forEach(button => {
  button.addEventListener('click', function (event) {
    // Get quantity (default to 1 or from input if available)
    const quantityInput = button.closest('.quick-add-to-cart')?.querySelector('input[name="quantity"]');
    const quantity = quantityInput ? parseInt(quantityInput.value) : 1;

    // Construct dataLayer object using data attributes
    const dataLayerPayload = {
      event: "view_item",
      ecommerce: {
        currency: window.Shopify?.currency?.active || "AED",
        value: parseFloat(button.dataset.price) || 0,
        items: [
          {
            name: button.dataset.title || "Linkstore Product",
            id: button.dataset.id || "Linkstore",
            price: parseFloat(button.dataset.price) || 0,
            quantity: quantity,
            category: button.dataset.category || "Linkstore Category",
            brand: button.dataset.brand || "Linkstore Brand",
            variant: button.dataset.variant || "Linkstore Variant"
          }
        ]
      }
    };

    // Push to dataLayer
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(dataLayerPayload);

    console.log('DataLayer Push:', dataLayerPayload);
  });
});


document.addEventListener("DOMContentLoaded", function () {

  let mobileFilter = null;
  let lastScrollTop = window.scrollY;
  let ticking = false;

  function detectMobileFilter() {
    mobileFilter = document.querySelector(
      ".usf-filters-horz .usf-nosearch .usf-sr-config"
    );
  }

  // Initial detect
  detectMobileFilter();

  // Detect dynamically injected USF element (mobile)
  const observer = new MutationObserver(detectMobileFilter);
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  function onScroll() {
    if (!mobileFilter) {
      ticking = false;
      return;
    }

    const currentScroll = window.scrollY;
    const isScrollUp = currentScroll < lastScrollTop && currentScroll > 5;

    if (isScrollUp) {
      mobileFilter.classList.add("filter--offset-mobile");
    } else {
      mobileFilter.classList.remove("filter--offset-mobile");
    }

    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
    ticking = false;
  }

  window.addEventListener("scroll", function () {
    if (!ticking) {
      requestAnimationFrame(onScroll);
      ticking = true;
    }
  }, { passive: true });

});
